"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M482 245.8h-22.8c-.4 0-.7.2-1 .2-5.1-46.9-44.4-83.5-92.7-83.5-36.1 0-67.2 20.7-82.8 50.7-9.7-5.7-20.4-9-31.8-9s-22.1 3.3-31.8 9c-15.6-30-46.6-50.7-82.8-50.7-48.2 0-87.5 36.5-92.7 83.3H21.7c-5.8 0-10.4 4.7-10.4 10.4 0 5.8 4.7 10.4 10.4 10.4h21.9c5.2 46.8 44.5 83.3 92.7 83.3 51.8 0 93.8-42 93.8-93.8 0-7.8-1.2-15.2-3-22.4 7.3-4.1 15.4-6.5 23.8-6.5 8.5 0 16.5 2.4 23.8 6.5-1.8 7.2-3 14.7-3 22.4 0 51.8 42 93.8 93.8 93.8 48.3 0 87.6-36.6 92.7-83.5.4 0 .7.2 1 .2H482c5.8 0 10.4-4.7 10.4-10.4s-4.6-10.4-10.4-10.4zm-345.7 83.3c-40.3 0-72.9-32.6-72.9-72.9 0-40.3 32.6-72.9 72.9-72.9 40.3 0 72.9 32.6 72.9 72.9 0 40.3-32.6 72.9-72.9 72.9zm229.2 0c-40.3 0-72.9-32.6-72.9-72.9 0-40.3 32.6-72.9 72.9-72.9 40.3 0 72.9 32.6 72.9 72.9 0 40.3-32.6 72.9-72.9 72.9z"
  });
};

exports.default = _default;